import { render, staticRenderFns } from "./dialogAddPosition.vue?vue&type=template&id=5c8f8f2e&scoped=true"
import script from "./dialogAddPosition.vue?vue&type=script&lang=js"
export * from "./dialogAddPosition.vue?vue&type=script&lang=js"
import style0 from "./dialogAddPosition.vue?vue&type=style&index=0&id=5c8f8f2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8f8f2e",
  null
  
)

export default component.exports